var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruitment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_33865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1997 14.5H24.1997V16.5H26.1997C27.8597 16.5 29.1997 17.84 29.1997 19.5V23.5H31.1997V19.5C31.1997 16.74 28.9597 14.5 26.1997 14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1997 4.5C25.8597 4.5 27.1997 5.84 27.1997 7.5C27.1997 9.16 25.8597 10.5 24.1997 10.5C22.5397 10.5 21.1997 9.16 21.1997 7.5C21.1997 5.84 22.5397 4.5 24.1997 4.5ZM24.1997 2.5C21.4397 2.5 19.1997 4.74 19.1997 7.5C19.1997 10.26 21.4397 12.5 24.1997 12.5C26.9597 12.5 29.1997 10.26 29.1997 7.5C29.1997 4.74 26.9597 2.5 24.1997 2.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1997 30.5H21.1997V28.5C21.1997 26.84 19.8597 25.5 18.1997 25.5H14.1997C12.5397 25.5 11.1997 26.84 11.1997 28.5V30.5H9.19971V28.5C9.19971 25.74 11.4397 23.5 14.1997 23.5H18.1997C20.9597 23.5 23.1997 25.74 23.1997 28.5V30.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1997 13.5C17.8597 13.5 19.1997 14.84 19.1997 16.5C19.1997 18.16 17.8597 19.5 16.1997 19.5C14.5397 19.5 13.1997 18.16 13.1997 16.5C13.1997 14.84 14.5397 13.5 16.1997 13.5ZM16.1997 11.5C13.4397 11.5 11.1997 13.74 11.1997 16.5C11.1997 19.26 13.4397 21.5 16.1997 21.5C18.9597 21.5 21.1997 19.26 21.1997 16.5C21.1997 13.74 18.9597 11.5 16.1997 11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19971 14.5H6.19971C3.43971 14.5 1.19971 16.74 1.19971 19.5V23.5H3.19971V19.5C3.19971 17.84 4.53971 16.5 6.19971 16.5H8.19971V14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19971 4.5C9.85971 4.5 11.1997 5.84 11.1997 7.5C11.1997 9.16 9.85971 10.5 8.19971 10.5C6.53971 10.5 5.19971 9.16 5.19971 7.5C5.19971 5.84 6.53971 4.5 8.19971 4.5ZM8.19971 2.5C5.43971 2.5 3.19971 4.74 3.19971 7.5C3.19971 10.26 5.43971 12.5 8.19971 12.5C10.9597 12.5 13.1997 10.26 13.1997 7.5C13.1997 4.74 10.9597 2.5 8.19971 2.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_33865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.199707 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment);
export default __webpack_public_path__ + "static/media/recruitment.b833717469e2f0cba04f51d061d2d480.svg";
export { ForwardRef as ReactComponent };